import lrCodeEditorButton from './_src/lrCodeEditorButton.vue'

lrCodeEditorButton.install = function(Vue) {
  Vue.component(lrCodeEditorButton.name, lrCodeEditorButton)
}

export default lrCodeEditorButton